import { Box, SxProps, Theme } from "@mui/material";

import AppIconButton from "@/common/components/Button/AppIconButton";
import InlineApiEnumValue from "@/common/components/Enum/InlineApiEnumValue";
import FieldValue from "@/common/components/Form/Display/FieldValue";
import AppPopover from "@/common/components/Popover/AppPopover";
import AppPopoverContent from "@/common/components/Popover/AppPopoverContent";
import { ApiEnumName } from "@/common/services/enum";
import { GeneralBillToInfoDto, GeneralBillToInfoInputDto } from "@/core/api/generated/v1";

import AppIcon from "../../../Icons/AppIcon";
import GeneralStrictEntityRelationLink from "../Display/GeneralStrictEntityRelationLink";

export function prepareGeneralBillToInfoInputDtoForApi(
  dto: GeneralBillToInfoInputDto | null | undefined,
): GeneralBillToInfoInputDto | undefined {
  return dto?.name ? dto : undefined;
}

interface Props {
  value: GeneralBillToInfoDto | null | undefined;
  withDetailsPopover?: boolean;
  sx?: SxProps<Theme>;
}

export function GeneralBillToInfoDisplay({ value, withDetailsPopover = false, sx }: Props) {
  if (!value) {
    return null;
  }

  return (
    <Box sx={sx}>
      {value?.name}{" "}
      {withDetailsPopover && (
        <AppPopover
          hoverBehavior={{ closeBehavior: "onTriggerOrContentMouseLeave" }}
          trigger={
            <AppIconButton sx={{ ml: 0.5 }} variant='text' size='extraSmall'>
              <AppIcon of='info' inText />
            </AppIconButton>
          }
        >
          <AppPopoverContent
            sx={{
              minWidth: { xxs: "90vw", md: 400, lg: 700 },
              maxHeight: { xxs: "80vh" },
            }}
          >
            <Box>
              <FieldValue label='Type'>{value?.isCustom ? "Custom" : "Auto-inferred"}</FieldValue>

              <FieldValue label='Source type' isEmpty={!value?.sourceType}>
                <InlineApiEnumValue type={ApiEnumName.BillToSourceType} value={value?.sourceType} />
              </FieldValue>

              <FieldValue label='Bill to name' isEmpty={!value?.name}>
                {value?.name}
              </FieldValue>

              <FieldValue label='Bill to' isEmpty={!value?.billToEntity}>
                <GeneralStrictEntityRelationLink value={value?.billToEntity} />
              </FieldValue>

              <FieldValue label='Inferred from' isEmpty={!value?.inferredFromEntity}>
                <GeneralStrictEntityRelationLink value={value?.inferredFromEntity} />
              </FieldValue>
            </Box>
          </AppPopoverContent>
        </AppPopover>
      )}
    </Box>
  );
}
